import React, { Component } from 'react'
import { connect } from 'react-redux'

class Teams extends Component {
  render() {
    const { structure, teams, component, data } = this.props
    let children = null
    if(structure){
      children = Object.keys(structure).map(teamId => {
        return (
          <div key={teamId} className="team">
            <h3>{teams[teamId].name}</h3>
            <div className="team-content">
              {React.createElement(component, {teamId, members: teams[teamId].members})}
            </div>
            <Teams structure={structure[teamId]} teams={teams} component={component} data={data} />
          </div>
        )
      })
    }
    return (
      <div className="teams">{children}</div>
    )
  }
}

export default connect(
  state => ({ 
    structure: state.organization.structure,
    teams: state.organization.teams
  })
)(Teams)



// WEBPACK FOOTER //
// ./src/components/Teams.js